import React, { useState } from 'react'
import axios from 'axios'
import { LocalizationContextType } from '../../shared/contexts'
import { admin_robot_sensor_path } from '../../../../routes'
import SensorCard, { Sensor } from './SensorCard'
import SensorFormModal, { SensorTypeOption } from './SensorFormModal'

interface SensorCardsProps {
  sensors: Sensor[]
  sensorTypes: SensorTypeOption[]
  canEdit?: boolean
  canDelete?: boolean
  localization_context?: LocalizationContextType
}

const SensorCards: React.FC<SensorCardsProps> = ({
  sensors,
  sensorTypes,
  canEdit = false,
  canDelete = false,
  localization_context: localizationContext
}) => {
  const [editedSensor, setEditedSensor] = useState<Sensor | null>(null)
  const [error, setError] = useState<string | null>(null)

  // Readings are keyed by sensor_id rather than by this row, so they outlive the sensor.
  const deleteSensor = (sensor: Sensor) => {
    const confirmed = window.confirm(
      `Delete "${sensor.sensor_name}"? Its recorded readings are kept for HACCP history.`
    )
    if (!confirmed) return

    setError(null)
    axios
      .delete(admin_robot_sensor_path(sensor.id))
      .then(() => window.location.reload())
      .catch((err) => setError(err.response?.data?.error || 'Could not delete the sensor.'))
  }

  return (
    <>
      {editedSensor && (
        <SensorFormModal
          sensorTypes={sensorTypes}
          sensor={editedSensor}
          localizationContext={localizationContext}
          onClose={() => setEditedSensor(null)}
          onSaved={() => window.location.reload()}
        />
      )}

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="sensor-cards">
        {sensors.map((sensor) => (
          <SensorCard
            key={sensor.id}
            sensor={sensor}
            localizationContext={localizationContext}
            canEdit={canEdit}
            canDelete={canDelete}
            onEdit={setEditedSensor}
            onDelete={deleteSensor}
          />
        ))}
      </div>
    </>
  )
}

export default SensorCards
